import React from "react";
import { IconLoader2 } from "@tabler/icons-react";
import styles from "./NewButton.module.css";

export default function NewButton({
  children,
  className,
  classNames,
  style,
  fullWidth,
  leftSection,
  rightSection,
  disabled = false,
  loading = false,
  type = "button",
  ...props
}) {
  const isDisabled = disabled || loading;
  const mergedClassName = [styles.button, fullWidth && styles.fullWidth, isDisabled && styles.disabled, className, classNames?.root]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    <button type={type} disabled={isDisabled} className={mergedClassName} style={style} {...props}>
      {loading ? <IconLoader2 className={styles.loader} size={50} stroke={2} /> : leftSection}
      {children}
      {loading ? null : rightSection}
    </button>
  );
}
